export const getters = {
  isLoading: state => state.isLoading,
  loadingCount: state => state.loadingCount,
};

export default getters;
